import { Box, DialogContent, Stack } from "@mui/material";
import {
  BottomSheet,
  Illustration,
  Text,
  Title,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";
import { isRebrandingEnabled } from "@src/appV2/redesign/system/ui-theme";
import Lottie from "lottie-react";

import { DialogFooter } from "../../components/DialogFooter";
import { LoadingButton } from "../../components/LoadingButton";
import clipboardMarkSuccessAnimation from "../../Onboarding/components/animations/clipboardMarkSuccess.json";
import { ReferralPostBookingCta } from "./ReferralPostBookingCta/ReferralPostBookingCta";

export interface ShortLeadTimeShiftBookedBottomSheetProps {
  modalState: UseModalState;
  workplaceName: string;
  shiftId: string;
  workplaceId: string;
  workplaceType: string | undefined;
  msa: string | undefined;
  onGetDirectionsClick?: () => void;
  directionsHref?: string;
}

export function ShortLeadTimeShiftBookedBottomSheet(
  props: ShortLeadTimeShiftBookedBottomSheetProps
) {
  const {
    modalState,
    onGetDirectionsClick,
    workplaceName,
    directionsHref,
    shiftId,
    workplaceId,
    workplaceType,
    msa,
  } = props;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical" sx={{ marginTop: 10 }}>
          <ReferralPostBookingCta
            shiftId={shiftId}
            workplaceId={workplaceId}
            workplaceType={workplaceType}
            msa={msa}
          />
          <LoadingButton
            fullWidth
            variant="contained"
            size="large"
            href={directionsHref}
            isLoading={false}
            onClick={onGetDirectionsClick}
          >
            Get directions
          </LoadingButton>
        </DialogFooter>
      }
    >
      <DialogContent sx={{ backgroundColor: "unset", py: 8, mt: 8 }}>
        <Stack direction="column" alignItems="center" spacing={9}>
          <Stack direction="column" alignItems="center" spacing={0}>
            {isRebrandingEnabled() ? (
              <Box sx={{ width: 240, marginBottom: "-40px" }}>
                <Lottie loop animationData={clipboardMarkSuccessAnimation} />
              </Box>
            ) : (
              <Illustration type="shift-booked" />
            )}
            <Title variant="h2" component="h2" sx={{ textAlign: "center" }}>
              See you soon!
            </Title>
          </Stack>

          <Stack spacing={1} sx={{ textAlign: "center" }}>
            <Text variant="body1" sx={(theme) => ({ color: theme.palette.text.secondary })}>
              {workplaceName} is counting on you!
            </Text>
            <Text variant="body1" sx={(theme) => ({ color: theme.palette.text.secondary })}>
              Please leave home as soon as possible.
            </Text>
          </Stack>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
